// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3dHn2","emails":"CreateEditClinics_emails__2b2YF","emailTagLabel":"CreateEditClinics_emailTagLabel__1sl3D"};